import script from "./AuctionLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuctionLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuctionLayout.vue?vue&type=style&index=0&id=d52ba156&lang=scss"
import "./AuctionLayout.vue?vue&type=style&index=1&id=d52ba156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d52ba156"]])

export default __exports__